import { StopType } from '../../shared/stop-type.model';
import { RandomUtils } from '../../shared/random-utils';
import { LocalLocation } from './local-location.model';

export class ManualLocalLoadCreationRequest {

  public loadId: string;
  public vehicle: string;
  public stops: ManualLocalLoadCreationStopRequest[] = [];

  public static prepopulate(vehicle?: string): ManualLocalLoadCreationRequest {
    const request   = new ManualLocalLoadCreationRequest();
    request.loadId  = RandomUtils.generateRandomInt(10);
    request.vehicle = vehicle;

    return request;
  }

  clone(): ManualLocalLoadCreationRequest {
    const clone = new ManualLocalLoadCreationRequest();

    clone.loadId  = this.loadId;
    clone.vehicle = this.vehicle;
    clone.stops   = this.stops.map(s => s.clone());

    return clone;
  }

  toDto(): any {
    return {
      load_id: this.loadId,
      vehicle: this.vehicle,
      stops: this.stops.map(s => s.toDto()),
    };
  }
}

export class ManualLocalLoadCreationStopRequest {

  public shipments: ManualLocalLoadCreationShipmentRequest[] = [];
  public type: StopType;
  public location: LocalLocation;

  clone(): ManualLocalLoadCreationStopRequest {
    const clone = new ManualLocalLoadCreationStopRequest();

    clone.type      = this.type;
    clone.location  = this.location;
    clone.shipments = this.shipments.map(s => s.clone());

    return clone;
  }

  toDto(): any {
    return {
      shipments: this.shipments.map(s => s.toDto()),
      type: this.type,
      location_id: this.location.id,
    };
  }
}

export class ManualLocalLoadCreationShipmentRequest {

  public deliveryNumber: string;
  public salesOrderNumber: string;
  public items: ManualLocalLoadCreationItemRequest[] = [];
  public pickLocation: LocalLocation;
  public dropLocation: LocalLocation;
  public pickLocationSearchString: string;
  public pickLocationSearchResult: LocalLocation[]   = [];
  public dropLocationSearchString: string;
  public dropLocationSearchResult: LocalLocation[]   = [];

  public static prepopulate(
    deliveryNumber: string = RandomUtils.generateRandomInt(10),
    salesOrderNumber: string = RandomUtils.generateRandomInt(10)
  ): ManualLocalLoadCreationShipmentRequest {
    const shipment          = new ManualLocalLoadCreationShipmentRequest();
    shipment.deliveryNumber = deliveryNumber;
    shipment.salesOrderNumber = salesOrderNumber;
    shipment.items          = [ManualLocalLoadCreationItemRequest.prepopulate()];

    return shipment;
  }

  clone(): ManualLocalLoadCreationShipmentRequest {
    const clone = new ManualLocalLoadCreationShipmentRequest();

    clone.deliveryNumber = this.deliveryNumber;
    clone.salesOrderNumber= this.salesOrderNumber;
    clone.pickLocation   = this.pickLocation;
    clone.dropLocation   = this.dropLocation;
    clone.items          = this.items.map(i => i.clone());

    return clone;
  }

  toDto(): any {
    return {
      delivery_number: this.deliveryNumber,
      sales_order_number: this.salesOrderNumber,
      items: this.items.map(i => i.toDto()),
    };
  }
}

export class ManualLocalLoadCreationItemRequest {

  public quantity: number;
  public productCode: string;
  public productDescription: string;

  constructor(quantity?: number, productCode?: string, productDescription?: string) {
    this.quantity           = quantity;
    this.productCode        = productCode;
    this.productDescription = productDescription;
  }

  public static prepopulate(): ManualLocalLoadCreationItemRequest {
    return new ManualLocalLoadCreationItemRequest(100, '00001', 'B1210A-1200x1000 Block Pallet');
  }

  clone(): ManualLocalLoadCreationItemRequest {
    const clone = new ManualLocalLoadCreationItemRequest();

    clone.quantity           = this.quantity;
    clone.productCode        = this.productCode;
    clone.productDescription = this.productDescription;

    return clone;
  }

  toDto(): any {
    return {
      quantity: this.quantity,
      product_code: this.productCode,
      product_description: this.productDescription,
    };
  }
}
